// extracted by mini-css-extract-plugin
export default {"wrapper":"YZ-z","play":"ZZ-z"};